<template>
  <general-text-field
    label="Name"
    dense autofocus
    v-bind:disabled="isImmutable"
    v-model="$_name"
  >
  </general-text-field>
</template>

<script>
import MarkerSegmentData from '../../../modules/segmentDataTypes/MarkerSegmentData.js';
import SegmentContentDataInputDefinition from '../../../modules/SegmentContentDataInputDefinition.js';
import GeneralTextField from './GeneralTextField.vue';

export const MarkerSegmentContentDataInputDefinition = new SegmentContentDataInputDefinition(
  'MarkerSegmentContentDataInput',
  MarkerSegmentData.contentData,
);

export default {
  model: {
    event: 'update',
    prop: 'timelineSegmentContentData'
  },

  components: {
    GeneralTextField,
  },

  props: {
    isImmutable:                { type: Boolean,                       required: true },
    timelineSegmentContentData: { type: MarkerSegmentData.contentData, required: true },
  },

  computed: {
    $_markerData: {
      get()         { return this.timelineSegmentContentData },
      set(markerData) { this.$emit('update', markerData) },
    },

    $_name: {
      get()     { return this.$_markerData.name },
      set(name) {
        let markerData = this.$_markerData.clone();
        markerData.name = name;
        this.$_markerData = markerData;
      },
    },
  },
}
</script>